import { getRenderStyleProperty } from '../../../../../../CanvasState/Helpers/Style/textBody';
import { getPrioritizedTextBody } from '../../../Utils/textBody';

const getTextDirection = shape => getRenderStyleProperty(shape, getPrioritizedTextBody(shape), ['textDirection']);

export default getTextDirection;
